import { defineMessages } from 'react-intl';

export const messages: {
	cardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	groupsFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyGroupsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confirmButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	expandBodyContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	collapseBodyContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successPill: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	cardTitle: {
		id: 'ai-mate.conversation-assistant-message-actions.update-request-type-portal-groups.card-title',
		defaultMessage: 'Update request type',
		description: 'Card title when updating the portal groups for a JSM request type',
	},
	groupsFieldLabel: {
		id: 'ai-mate.conversation-assistant-message-actions.update-request-type-portal-groups.groups-field-label',
		defaultMessage: 'Following are the updated portal groups:',
		description:
			'Label for the portal groups list in the update request type portal groups card body',
	},
	emptyGroupsDescription: {
		id: 'ai-mate.conversation-assistant-message-actions.update-request-type-portal-groups.empty-groups-description',
		defaultMessage:
			"This request type won’t be assigned to any portal groups, so it won't appear in your help center.",
		description:
			'Message shown in the update request type portal groups card when no portal groups will be assigned.',
	},
	confirmButton: {
		id: 'ai-mate.conversation-assistant-message-actions.update-request-type-portal-groups.confirm-button',
		defaultMessage: 'Update',
		description: 'Label for the confirm button when updating request type portal groups',
	},
	expandBodyContent: {
		id: 'ai-mate.conversation-assistant-message-actions.update-request-type-portal-groups.expand-body-content',
		defaultMessage: 'Show more',
		description:
			'Button label to expand the card content area when text exceeds the visible height',
	},
	collapseBodyContent: {
		id: 'ai-mate.conversation-assistant-message-actions.update-request-type-portal-groups.collapse-body-content',
		defaultMessage: 'Show less',
		description:
			'Button label to collapse the card content area after it was expanded for long text',
	},
	successPill: {
		id: 'ai-mate.conversation-assistant-message-actions.update-request-type-portal-groups.success-pill',
		defaultMessage: `You've updated "{requestTypeName}"`,
		description:
			'Pill message shown after request type portal groups update succeeds. {requestTypeName} is the request type name.',
	},
});
